import { updateKeyInStore } from 'App';
import {
  DeductionsStateValues,
  TListOfChildcareProvidersRow,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  keyof DeductionsStateValues | keyof TListOfChildcareProvidersRow
>[] = [
  {
    name: 'doYouHaveAMortgagePleaseUploadForm1098',
    label: 'Do you have a Mortgage, please upload Form 1098',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.taxesDeductions.deductions.values.didYouOwnResidentialRealEstateDuringYear',
  },
  {
    name: 'ifNonUsMortgagePleaseUploadBankStatementShowingTheAmountOfMortgageInterestPaidThroughTheCalendarYear',
    label:
      'If Non-US mortgage, please upload bank statement showing the amount of mortgage interest paid through the calendar year',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.taxesDeductions.deductions.values.didYouOwnResidentialRealEstateDuringYear',
  },
  {
    name: 'pleaseUploadForms5498SaAnd1099SaIfReceived',
    label: 'Please upload Forms 5498-SA and 1099-SA if received',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.taxesDeductions.deductions.values.doYouHaveAnHsaAccount',
  },
  {
    dependenciesTitle: 'Education',
    name: 'didYouPayInterestOnStudentLoans',
    label: 'Did you pay Interest on Student Loans?',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.taxesDeductions.deductions.values.doYouWantToListVariousExpensesThatMightImproveYourTaxPosition',
  },
  {
    name: 'form1098E',
    label: 'Form 1098E',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.taxesDeductions.deductions.values.didYouPayInterestOnStudentLoans',
  },
  {
    name: 'form1098T',
    label: 'Form 1098T',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.taxesDeductions.deductions.values.didYouIncurHigherEducationExpensesForYourselfSpouseOrDependents',
  },
  {
    name: 'form1098C',
    label: 'Form 1098C',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.taxesDeductions.deductions.values.didYouDonateAVehicleBoatOrAirplaneWithTheClaimedValueOver500',
  },
  {
    name: 'pleaseUploadAllTheRelatedDeductions',
    label: 'Please upload all the related deductions',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.taxesDeductions.deductions.values.doesTheJobRelatedExpensesExceedsTheStandardDeduction',
  },
];
